import { toBoolean } from '../../../utils/booleanUtils';
import ActionMenu from '../../../shared/components/common/ActionMenu';

/**
 * Users-page action menu — builds user-specific actions for shared ActionMenu.
 */
function ActionDropdown({
  user,
  currentUser,
  isLoading,
  onEdit,
  onSendVerificationEmail,
  onResendVerificationEmail,
  onSendReactivationLink,
  onResendReactivationLink,
  onRevokeLink,
  onDelete
}) {
  const inactive = !toBoolean(user.is_active);
  const emailVerified = toBoolean(user.email_verified);
  const awaitingVerification = !emailVerified;
  const deactivatedVerified = emailVerified;

  const pendingLinkMeta = user.pending_link;
  const hasPendingLink = !!pendingLinkMeta;
  const hasActivePendingLink = !!(pendingLinkMeta && !pendingLinkMeta.is_expired);

  const isSelfUser = user.id === currentUser?.id;
  const isUserViewOnly = isSelfUser;

  const showLockedViewUserAction =
    inactive &&
    ((awaitingVerification && hasActivePendingLink) || deactivatedVerified);

  const actions = [
    {
      id: 'edit',
      icon: showLockedViewUserAction ? '🔒' : '✏️',
      label: showLockedViewUserAction ? 'View User' : 'Edit User',
      show: !isUserViewOnly,
      onClick: onEdit
    },
    {
      id: 'send-verification',
      icon: '📧',
      label: awaitingVerification && hasActivePendingLink ? 'Resend Verification Email' : 'Send Verification Email',
      show: inactive && awaitingVerification,
      disabled: isLoading?.sendVerification,
      loading: isLoading?.sendVerification,
      onClick:
        awaitingVerification && hasActivePendingLink ? onResendVerificationEmail : onSendVerificationEmail
    },
    {
      id: 'send-reactivation',
      icon: '🔗',
      label: deactivatedVerified && hasActivePendingLink ? 'Resend Reactivation Link' : 'Send Reactivation Link',
      show: inactive && deactivatedVerified,
      disabled: isLoading?.sendReactivation,
      loading: isLoading?.sendReactivation,
      onClick:
        deactivatedVerified && hasActivePendingLink ? onResendReactivationLink : onSendReactivationLink
    },
    {
      id: 'revoke',
      icon: '🚫',
      label: 'Revoke Pending Link',
      show: inactive && hasPendingLink,
      disabled: isLoading?.revoke,
      loading: isLoading?.revoke,
      onClick: onRevokeLink
    },
    {
      id: 'delete',
      icon: '✕',
      label: 'Delete User',
      show: currentUser?.role === 'superadmin' && !isUserViewOnly,
      danger: true,
      onClick: onDelete
    }
  ];

  return (
    <ActionMenu
      actions={actions}
      disabled={isLoading?.any}
      title="Actions menu"
      emptyLabel="View Only"
    />
  );
}

export default ActionDropdown;
